import {
  ICreateInsuranceCoverageMonitorSettingsRequest,
  IInsuranceCoverageMonitorSettings
} from "./types";
import { monitorSettingsService } from "./service";

export const createMonitorSettings = async (
  request: ICreateInsuranceCoverageMonitorSettingsRequest
): Promise<IInsuranceCoverageMonitorSettings> => {
  const { data } =
    await monitorSettingsService.post<IInsuranceCoverageMonitorSettings>(
      `/`,
      request
    );

  return data;
};
